var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName,"appear":""},on:{"after-leave":_vm.onLeave}},[_c('div',{ref:"dialog",staticClass:"dialog",on:{"click":function($event){$event.stopPropagation();return (() => _vm.$emit('click')).apply(null, arguments)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }